import React, { useEffect,useState } from "react";
import ViewModel from "../modal/ViewModal";
import AuthContext from "../../AuthContext";
import axiosInstance from "../../axiosInstance";
import './teacher.css'
import { Button } from "@mui/material";
import Snackbar from "../Snackbar"
import MUIDataTable from "mui-datatables";
import Loader from "../Loader";




const BASE_URL = process.env.REACT_APP_BASE_URL;


const Teacher =()=>{
   const [loading,setLoading] = useState(false);
    const [data,setData] = useState([]);
    const [isOpen,setIsOpen] = useState(false);
    const [mode,setMode] = useState('Add');
    const [isAdded,setIsAdded] = useState(false)

    const [teacherDetail,setTeacherDetail] = useState([])
    const [message,setSnackMessage] = useState('');
    const [snack,setSnack] = useState(false)
    const [type,setType] = useState("success");
    const [originalData,setOriginalData] = useState([]);
    // const { loading, showLoader, hideLoader } = useLoader();

 

    const columns = [
      
        {
            name: "code",
            label: "Code",
            flex: (window.innerWidth) <768 ?0.6:0.2,
            headerClassName: 'custom-header-code'

        },
        {
            name:"id",
            label:"Id",
            options: { display: 'excluded' } 
        },
        {
            name: "name",
            label: "Teacher",
            flex:1,
            renderCell: (params) => (
                <div style={{ whiteSpace: "normal", wordWrap: "break-word", lineHeight: "1.2em" }}>
                  {params.value}
                </div>
              ),

          
             headerClassName: 'custom-header-name'
        },

        {
            name: "center",
           label: "Center",
            flex:1,
            renderCell: (params) => (
                <div style={{ whiteSpace: "normal", wordWrap: "break-word", lineHeight: "1.2em" }}>
                  {params.value}
                </div>
              ),
          
            headerClassName: 'custom-header-name'

        }

    ];
    useEffect(() =>{
       

       setLoading(true);
        if(isOpen===false ){
           // showLoader()
            axiosInstance.get('/getAllteacher').then((res)=>{
                setData(res.data)
                setOriginalData(res.data);

    
            }).then((r)=>{
                console.log(r,"res");
            }).finally(()=>{
                setLoading(false)
            })

        }
        
      

    },[])

      useEffect(() =>{
       

       setLoading(true);
        if(isAdded===true ){
           // showLoader()
            axiosInstance.get('/getAllteacher').then((res)=>{
                setData(res.data)
                setOriginalData(res.data);

    
            }).then((r)=>{
                console.log(r,"res");
            }).finally(()=>{
                setLoading(false)
            })

        }
        
      

    },[isAdded])

   

   
    const setMessage = (message) =>{
        setSnackMessage(message);
    
    }


    const openAddModal =() =>{

       setIsOpen(true);
       setTeacherDetail({})
       setMode("add")

    }

    const handleDownloadExcel = async () => {
        try {
            setLoading(true);
            const response = await axiosInstance.get('/api/teacher/export/excel', {
                responseType: 'blob',
            });
            const blob = new Blob([response.data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            const today = new Date().toISOString().split('T')[0];
            link.download = `Teachers_Data_${today}.xlsx`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error downloading teacher Excel:', error);
            alert('Failed to download Excel: ' + (error.response?.data || error.message));
        } finally {
            setLoading(false);
        }
    };




    const onRowClick=(e)=>{
        setLoading(true);
       axiosInstance.get(`${BASE_URL}/getTeacher?id=${e[1]}`,{withCredentials:true}).then((resp)=>{
            setTeacherDetail(resp.data)
            setIsOpen(true)
            setMode("View")


        }).catch((err)=>{

        }).finally(()=>{
            setLoading(false)
        })
        

    }

    const options = {
        rowsPerPage: 100, 
        rowsPerPageOptions: [100, 500, 1000], 
        selectableRows: "none" ,
        responsive: "standard",
        onTableChange:(action,state) =>{
        

            console.log(action,"actionTable")

        },
        onRowClick: (rowData, rowMeta) => {
            setIsAdded(false)
            console.log('Row clicked:', rowMeta);
            onRowClick(rowData);
          },
         
      };


    return (
        <AuthContext.Provider value={{teachers:data }}>
     
        <div className="teacher-container">
        {loading && <Loader />}

            <div className="componet_header">
                <div className="Header">
                        TEACHER
                </div>
                <div style={{ display: 'flex', gap: '10px' }}>
                    <Button
                        className="mui-button"
                        onClick={handleDownloadExcel}
                        disabled={loading}
                        style={{ backgroundColor: '#4caf50', color: 'white' }}
                    >
                        {loading ? '⏳ Processing...' : '📊 Download Excel'}
                    </Button>
                    <Button className="mui-button" onClick={openAddModal}>
                        Add New
                    </Button>
                </div>
               
            </div>
           

            <div className="table-wrapper">
               
                  <MUIDataTable
                    data={data}
                    columns={columns}
                    options={options}
                  />
            </div>

            {isOpen && (
                <ViewModel 
                    closeAddModal={() => {
                        setIsOpen(false)
                        setSnack(true)
                        // setMessage("");


                    }} 
                    data={teacherDetail} 
                    open={isOpen} 
                    mode={mode}  
                    setMessage={setMessage}
                    setIsAdded={setIsAdded}
                    setType={setType}
                />
            )}
            <Snackbar message={message} snackType={type} open={snack} handleClose={()=>{setSnack(false)}}/>
        </div>
    </AuthContext.Provider>
    )

}


export default Teacher;